export class CurrencyRateCache {
  static indexCacheKey() {
    return `currency-rates`;
  }
  static lastDefaultCacheKey() {
    return `last-default-currency-rate`;
  }
}
